import styled from 'styled-components';

export const ContentAction = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;

  h6 {
    ${(props) => props.theme.config.typograph.xsmall};
    color: ${(props) => props.theme.config.colors.gray_400};
  }
`;

export const Student = styled.div`
  display: flex;
  flex-direction: column;

  span:last-child {
    ${(props) => props.theme.config.typograph.xsmall};
    color: ${(props) => props.theme.config.colors.gray_400};
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Results = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: ${(props) => (props.$scrollable ? 'auto' : 'hidden')};
  transition: opacity 0.2s;

  tbody tr {
    cursor: pointer;

    &:hover {
      background-color: ${(props) => props.theme.config.colors.gray_100};
    }
  }

  &[aria-busy='true'] {
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const Error = styled.p`
  padding: 2.4rem 0;
  text-align: center;
  ${(props) => props.theme.config.typograph.default};
  color: ${(props) => props.theme.config.colors.gray};
`;

// WidgetEmptyData is sized for a whole card; here it shares the card with the filters.
export const EmptyState = styled.div`
  height: 100%;

  & > div {
    height: 100%;
  }
`;

export const Sentinel = styled.div`
  height: 1px;
`;

export const LoadingMore = styled.div`
  display: flex;
  justify-content: center;
  padding: 1.2rem 0;
`;
